import styled from "styled-components";
import { withAppHOC } from "../../hoc";
import { StyledPageHeading, StyledPageBody } from "../../components/Styled";

const StyledFlexBoxContainer = styled.section`
  display: flex;
  column-gap: 100px;
`;

const StyledImageContainer = styled.section`
  width: 500px;
  max-width: 500px;
  height: fit-content;
  border-radius: 20px;
  position: relative;
  img {
    width: inherit;
    height: inherit;
    border-radius: inherit;
  }
  &:hover {
    section{
    top: 0px;
    left: 0px;
    transition: top 0.5s ease, left 0.5s ease;
  }
`;

const StyledImageOutline = styled.section`
  width: calc(100% - 20px);
  height: calc(100% - 20px);
  position: absolute;
  top: 30px;
  left: 30px;
  border-radius: 40px;
  border: 2px solid #f3f3f3;
  z-index: -1;
  transition: top 0.5s ease, left 0.5s ease;
`;

const StyledDataContainer = styled.section``;

const About = () => {
  return (
    <>
      <StyledPageHeading>
        <h1>About Us</h1>
      </StyledPageHeading>
      <StyledPageBody>
        <StyledFlexBoxContainer>
          <StyledDataContainer>
            <p>
              Nature's Fresh Farm is focused on bringing wholesome, farm-fresh
              products directly to the local communities in Hyderabad.
            </p>
            <h2>Our business model emphasizes: </h2>
            <ol>
              <li>
                <h3>Farm-to-Table Delivery</h3>
                <p>
                  We provide a farm-to-table service, delivering our products
                  directly to customers' homes in Hyderabad. This model ensures
                  customers receive the freshest milk, eggs, and produce, while
                  also supporting local, sustainable agriculture.
                </p>
              </li>
              <li>
                <h3>Subscription Services</h3>
                <p>
                  We offer convenient subscription services, allowing customers
                  to schedule regular deliveries of milk, eggs, and other
                  farm-fresh items. This ensures they always have access to
                  fresh products while supporting a healthy and eco-friendly
                  lifestyle.
                </p>
              </li>
              <li>
                <h3>Community Engagement and Education</h3>
                <p>
                  We believe in connecting with our community and regularly host
                  farm tours and workshops. This allows customers to experience
                  our farming practices firsthand, ask questions, and understand
                  the importance of sustainable agriculture.
                </p>
              </li>
              <li>
                <h3>Partnerships with Local Businesses</h3>
                <p>
                  {" "}
                  Nature's Fresh Farm collaborates with local cafes,
                  restaurants, and stores to bring our fresh products to a
                  broader audience. By supporting local businesses, we
                  contribute to the local economy and promote sustainable food
                  choices in Hyderabad.
                </p>
              </li>
            </ol>

            <p>
              By focusing on freshness, quality, and sustainability, Nature's
              Fresh Farm is proud to bring the natural goodness of the farm
              directly to your home. We are committed to offering high-quality,
              healthy products that reflect our dedication to ethical farming
              and environmental responsibility.
            </p>
          </StyledDataContainer>
          <StyledImageContainer>
            <StyledImageOutline />
            <img src="/about-02.png" alt="Four Seasons Fresh" />
          </StyledImageContainer>
        </StyledFlexBoxContainer>
      </StyledPageBody>
    </>
  );
};

export default withAppHOC(About);
